import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Package, ShoppingBag, Users, Image as ImageIcon,
  Quote, Settings, CalendarClock, LogOut, Menu,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";
import OverviewTab from "@/pages/admin/tabs/OverviewTab";
import ProductsTab from "@/pages/admin/tabs/ProductsTab";
import OrdersTab from "@/pages/admin/tabs/OrdersTab";
import LeadsTab from "@/pages/admin/tabs/LeadsTab";
import GalleryTab from "@/pages/admin/tabs/GalleryTab";
import TestimonialsTab from "@/pages/admin/tabs/TestimonialsTab";
import SettingsTab from "@/pages/admin/tabs/SettingsTab";
import CampaignTab from "@/pages/admin/tabs/CampaignTab";

const TABS = [
  { key: "overview", label: "Visão geral", icon: LayoutDashboard, C: OverviewTab },
  { key: "products", label: "Produtos (Loja)", icon: Package, C: ProductsTab },
  { key: "orders", label: "Pedidos", icon: ShoppingBag, C: OrdersTab },
  { key: "leads", label: "Orçamentos (Leads)", icon: Users, C: LeadsTab },
  { key: "gallery", label: "Galerias", icon: ImageIcon, C: GalleryTab },
  { key: "testimonials", label: "Depoimentos", icon: Quote, C: TestimonialsTab },
  { key: "campaign", label: "Campanha do Evento", icon: CalendarClock, C: CampaignTab },
  { key: "settings", label: "Marca & Contatos", icon: Settings, C: SettingsTab },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [active, setActive] = useState("overview");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.title = "Painel | K8 Admin";
    if (user === false) navigate("/admin");
  }, [user]);

  if (!user || user === false) {
    return <div className="min-h-screen flex items-center justify-center" style={{ background: "#0A0A0E", color: "#fff" }}>Carregando...</div>;
  }

  const Current = TABS.find((t) => t.key === active)?.C || OverviewTab;

  return (
    <div className="min-h-screen flex" style={{ background: "#0A0A0E", color: "#F8FAFC" }}>
      {/* Sidebar */}
      <aside className={`${open ? "fixed inset-y-0 left-0 z-40 w-64" : "hidden"} lg:flex lg:w-64 flex-col border-r border-white/10 bg-[#13131A]`}>
        <div className="h-16 flex items-center px-6 border-b border-white/10 font-head font-black text-lg">K8 Admin</div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {TABS.map((t) => (
            <button key={t.key} onClick={() => { setActive(t.key); setOpen(false); }} data-testid={`admin-tab-${t.key}`}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                active === t.key ? "bg-[var(--accent)] text-black" : "text-[var(--text-muted)] hover:bg-white/5 hover:text-white"
              }`}>
              <t.icon size={18} /> {t.label}
            </button>
          ))}
        </nav>
        <button onClick={logout} data-testid="admin-logout" className="m-3 flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-red-400 hover:bg-white/5">
          <LogOut size={18} /> Sair
        </button>
      </aside>

      {/* Main */}
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-16 flex items-center justify-between px-4 sm:px-6 border-b border-white/10 bg-[#13131A]">
          <button className="lg:hidden" onClick={() => setOpen((v) => !v)}><Menu /></button>
          <div className="font-head font-bold">{TABS.find((t) => t.key === active)?.label}</div>
          <div className="text-sm text-[var(--text-muted)] hidden sm:block">{user.email}</div>
        </header>
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
          <Current />
        </main>
      </div>
    </div>
  );
}
